import { render } from "./allPayments.vue?vue&type=template&id=1f295834&scoped=true"
import script from "./allPayments.vue?vue&type=script&lang=js"
export * from "./allPayments.vue?vue&type=script&lang=js"

import "./allPayments.vue?vue&type=style&index=0&id=1f295834&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/twiga_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f295834"]])

export default __exports__